/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementListMemberAddressResponse } from './MemberManagementListMemberAddressResponse';

export type MemberManagementListMemberAddressResponseApiRespoonse = {
    data?: MemberManagementListMemberAddressResponse;
    status?: MemberManagementListMemberAddressResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementListMemberAddressResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

